// components/categories/CornerBracket.tsx
'use client';

import React from 'react';

type Corner = 'tl' | 'tr' | 'bl' | 'br';

interface CornerBracketProps {
    corner: Corner;
    size?: number;
    thickness?: number;
    color?: string;
    className?: string;
    style?: React.CSSProperties;
}

export const CornerBracket: React.FC<CornerBracketProps> = ({
    corner,
    size = 16,
    thickness = 1.5,
    color = '#B08D57',
    className = '',
    style = {},
}) => {
    const isTop = corner === 'tl' || corner === 'tr';
    const isLeft = corner === 'tl' || corner === 'bl';

    const originMap: Record<Corner, string> = {
        tl: 'top left',
        tr: 'top right',
        bl: 'bottom left',
        br: 'bottom right',
    };

    return (
        <span
            aria-hidden="true"
            className={className}
            style={{
                position: 'absolute',
                width: size,
                height: size,
                ...(isTop ? { top: -4 } : { bottom: -4 }),
                ...(isLeft ? { left: -4 } : { right: -4 }),
                borderTopWidth: isTop ? thickness : 0,
                borderBottomWidth: !isTop ? thickness : 0,
                borderLeftWidth: isLeft ? thickness : 0,
                borderRightWidth: !isLeft ? thickness : 0,
                borderStyle: 'solid',
                borderColor: color,
                transformOrigin: originMap[corner],
                pointerEvents: 'none',
                zIndex: 10,
                ...style,
            }}
        />
    );
};